/**
 * V2 dashboard period model — Today / 7d / 30d / Custom, resolved server-side
 * in the entity's reporting timezone (GET /{scope}/dashboard/{tab}?period=...).
 * `week` / `month` stay parseable for bookmarks / API aliases.
 */
export const PERIOD_LABEL = {
    today: 'Today',
    week: 'This week',
    month: 'This month',
    '7d': '7d',
    '30d': '30d',
    custom: 'Custom',
};
/** Presets shown in PeriodPicker (ledger-aligned). */
export const DASHBOARD_PERIODS = [
    { value: 'today', label: PERIOD_LABEL.today },
    { value: '7d', label: PERIOD_LABEL['7d'] },
    { value: '30d', label: PERIOD_LABEL['30d'] },
    { value: 'custom', label: PERIOD_LABEL.custom },
];
const VALID_PERIODS = new Set([
    ...DASHBOARD_PERIODS.map((p) => p.value),
    'week',
    'month',
]);
/** Parse an untrusted period value (URL param); falls back to 'today'. */
export function parseDashboardPeriod(raw) {
    return VALID_PERIODS.has(raw || '') ? raw : 'today';
}
/** Validate custom calendar bounds (YYYY-MM-DD inclusive). */
export function validateDashboardCustomPeriod(dateFrom, dateTo) {
    const from = (dateFrom || '').trim();
    const to = (dateTo || '').trim();
    if (!from)
        return 'From date is required.';
    if (!to)
        return 'To date is required.';
    if (from > to)
        return 'From must be on or before To.';
    return null;
}
/** Build query params for dashboard V2 endpoints. */
export function toDashboardPeriodQuery(selection) {
    const q = { period: selection.period };
    if (selection.period === 'custom') {
        if (selection.dateFrom)
            q.date_from = selection.dateFrom;
        if (selection.dateTo)
            q.date_to = selection.dateTo;
    }
    return q;
}
